/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'house': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M3 11l9-8 9 8" _fill="none" _stroke="#1e3a8a" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path pid="1" d="M5 10v10a1 1 0 001 1h4v-6h4v6h4a1 1 0 001-1V10" _fill="none" _stroke="#1e3a8a" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>'
  }
})
